import { IssueData, ZodIssueCode } from 'zod';
import { doesExist } from 'utils/tsHelpers';

/**
 *  Util to validate condition values.
 *  Checks if the condition doesn't have a missing value or values or
 *  if the condition doesn't have both value or values.
 */
export const validateEmptyValue = <T>(
  {
    value,
    values,
  }: {
    value?: T;
    values?: string[];
  },
  addIssue: (arg: IssueData) => void,
) => {
  if (!(doesExist(value) || Array.isArray(values))) {
    addIssue({
      code: ZodIssueCode.custom,
      message: 'missing value',
      path: ['value'],
    });
  }
  if (doesExist(value) && Array.isArray(values)) {
    addIssue({
      code: ZodIssueCode.custom,
      message: 'missing value',
      path: ['value'],
    });
  }
};
